import { signOut, fetchWithTokenRefresh } from './AuthActions';
import {
  current_user_returned,
  users_returned,
  new_user_received,
  set_user_profile,
  set_user_shoutouts_as_read,
  users_requested,
  user_updated
} from './types';
import env from '../globals/environment';
import socket from '../globals/socket';


export const getCurrentUser = (update = false) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const { currentUser } = state.usersStore;

      if (currentUser === null) {
        const { headers } = state.authStore;
        socket.onConnectionID(async id => {
          const temp = await fetchWithTokenRefresh(`${env.backendUrl}/socket/${id}`, { headers })(dispatch);
          if (!temp.ok) console.log(temp);
        });

        const response = await fetchWithTokenRefresh(`${env.backendUrl}/users/current`, { headers })(dispatch);

        if (!response.ok) {
          dispatch(signOut());
        } else {
          const currentUser = await response.json();
          dispatch({
            type: current_user_returned,
            payload: fixUser(currentUser)
          });
        }
      } else if (update) {
        const { headers } = state.authStore;
        const response = await fetchWithTokenRefresh(`${env.backendUrl}/users/current`, { headers })(dispatch);
        const currentUser = await response.json();
        dispatch({
          type: current_user_returned,
          payload: fixUser(currentUser)
        });
      }
    } catch (error) {
      console.log(error);
      dispatch(signOut());
    }
  };
};

export const getUsers = (refresh) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const { users } = state.usersStore;

      if (users.length === 0 || refresh) {
        dispatch({ type: users_requested });
        const { headers } = getState().authStore;

        const response = await fetchWithTokenRefresh(`${env.backendUrl}/users`, { headers })(dispatch);

        if (!response.ok) throw new Error('Could not get users from api');
        else {
          const users = await response.json();

          dispatch({
            type: users_returned,
            payload: users.map(user => fixUser(user))
          });
        }

        socket.on('user', user => dispatch({
          type: new_user_received,
          payload: fixUser(user)
        }));

        socket.on('user-update', (user) => dispatch({
          type: user_updated,
          payload: user
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const settingProfile = user => {
  // console.log(user.name);
  return { type: set_user_profile, payload: user };
};

export const markAsRead = () => {
  return { type: set_user_shoutouts_as_read };
};

export const updateUser = (user) => {
  return async (dispatch, getState) => {
    try {
      const { headers } = getState().authStore;
      const url = `${env.backendUrl}/users/${user._id}`;
      await fetchWithTokenRefresh(url, { headers, method: "PUT", body: JSON.stringify(user) })(dispatch);
      await getCurrentUser();
    } catch (error) {
      console.log(error);
    }
  };
};

const fixUser = user => {
  let fixedUser = { ...user };
  fixedUser.title = user.title || "Employee";
  fixedUser.displayName = user.name;
  fixedUser.uid = user._id;
  fixedUser.photoURL = user.picture;

  return fixedUser;
};



// WEBPACK FOOTER //
// ./src/actions/UsersActions.js